import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import HrbTranslate from '../../../components/language/HrbTranslate';
import Lang from '../../../components/language/services/Lang';
import CollapsibleCardContent from '../../../components/library/stacking-collapsible-cards/CollapsibleCardContent';
import StackableCardWrapper from '../../../components/library/stacking-collapsible-cards/StackableCardWrapper';
import CollapsibleCardHeader from '../../../components/library/stacking-collapsible-cards/CollapsibleCardHeader';

const QuickLinksCard = () => {

    const { taxYear } = useRouteMatch().params

    const lang = useSelector(state => state.layout.lang)

    const linkTo = linkKey =>
        <a id={`link-to-${linkKey}`} href={Lang.getValue(`Links.Urls.${linkKey}`, lang)} target="blank">
            <HrbTranslate text={`Links.Labels.${linkKey}`} />
        </a>

    return (
        <StackableCardWrapper className='card-quick-links'>
            <CollapsibleCardHeader>
                <div className='column is-9'>
                    <h4><HrbTranslate text='Account.Headers.QuickLinks' /></h4>
                </div>
            </CollapsibleCardHeader>
            <CollapsibleCardContent className='py-3'>               
                <div className='column is-3'>
                    {linkTo('CRA')}<br />
                    {linkTo('RQ')}
                </div>
                
            </CollapsibleCardContent>
        </StackableCardWrapper>
    )
}

export default QuickLinksCard